// extracted by mini-css-extract-plugin
export default {"search-bar":"wcquKjpy6IOIR27EEwdH"};